import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DownLoadFile} from "../../shared/interface/fileReader.interface";

@Injectable({
    providedIn: 'root'
})

export class FileReaderService {
    static readFile(file, type: string) {
        let readerObj;
        return Observable.create(observer => {
            if (type === 'unsupported') {
                observer.error(file);
                observer.complete();
            } else {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    readerObj = {
                        filesource: e.target.result,
                        ready: true
                    };
                    observer.next(readerObj);
                    observer.complete();
                };
                if (type === 'application/pdf') {
                    reader.readAsArrayBuffer(file);
                } else {
                    reader.readAsDataURL(file);
                }
            }
        });
    }
  // *** Downloads the file ***
  // @params [downloadFile, filename]=> downloadFile.file contains the file
  static downloadFile(downloadFile: DownLoadFile, filename: string) {
    const url = window.URL.createObjectURL(downloadFile.file);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      link.remove();
    }, 100);
  }
}
